export const AGE_RANGE_MIN = 0;
export const AGE_RANGE_MAX = 8;

const OPEN_ENDED_PATTERN = /^(\d{1,2})\+$/;
const BOUNDED_PATTERN = /^(\d{1,2})-(\d{1,2})$/;

const toNumber = (value) => {
  if (value === '' || value === null || value === undefined) {
    return '';
  }

  const parsed = Number.parseInt(value, 10);
  return Number.isNaN(parsed) ? '' : parsed;
};

const isWithinBounds = (value) => Number.isInteger(value) && value >= AGE_RANGE_MIN && value <= AGE_RANGE_MAX;

export const parseAgeRange = (value, options = {}) => {
  const normalizedValue = String(value || '').trim();

  if (options.allowAllAges && normalizedValue === 'all') {
    return { mode: 'all', minAge: '', maxAge: '' };
  }

  const openMatch = normalizedValue.match(OPEN_ENDED_PATTERN);
  if (openMatch) {
    return {
      mode: 'open',
      minAge: toNumber(openMatch[1]),
      maxAge: ''
    };
  }

  const boundedMatch = normalizedValue.match(BOUNDED_PATTERN);
  if (boundedMatch) {
    return {
      mode: 'range',
      minAge: toNumber(boundedMatch[1]),
      maxAge: toNumber(boundedMatch[2])
    };
  }

  return {
    mode: 'range',
    minAge: '',
    maxAge: ''
  };
};

export const formatAgeRangeDraft = (draft, options = {}) => {
  if (!draft) {
    return '';
  }

  if (options.allowAllAges && draft.mode === 'all') {
    return 'all';
  }

  const minAge = toNumber(draft.minAge);
  const maxAge = toNumber(draft.maxAge);

  if (draft.mode === 'open') {
    return minAge === '' ? '' : `${minAge}+`;
  }

  if (minAge === '' || maxAge === '') {
    return '';
  }

  return `${minAge}-${maxAge}`;
};

export const validateAgeRangeDraft = (draft, options = {}) => {
  if (!draft) {
    return 'Age range is required.';
  }

  if (options.allowAllAges && draft.mode === 'all') {
    return '';
  }

  const minAge = toNumber(draft.minAge);
  const maxAge = toNumber(draft.maxAge);

  if (minAge === '') {
    return 'Start age is required.';
  }

  if (!isWithinBounds(minAge)) {
    return `Start age must be between ${AGE_RANGE_MIN} and ${AGE_RANGE_MAX}.`;
  }

  if (draft.mode === 'open') {
    return 'Open-ended age ranges are not supported for the current 0-8 target audience.';
  }

  if (maxAge === '') {
    return 'End age is required.';
  }

  if (!isWithinBounds(maxAge)) {
    return `End age must be between ${AGE_RANGE_MIN} and ${AGE_RANGE_MAX}.`;
  }

  if (maxAge <= minAge) {
    return maxAge === minAge
      ? 'Use a range like 4-7.'
      : 'End age must be greater than start age.';
  }

  return '';
};
